/**
 * One vocabulary for a task's status across the console and the phone. The words are the workbench's
 * board columns (`webview-ui/src/components/tasks/TasksView.tsx` COLUMN_LABELS), plus "Cancelled"
 * from its task closure words (`shared/protocol/taskClosure.ts`). Never show a raw status id
 * ("in-progress", "todo") to a person: use `taskStatusText`.
 */
export const TASK_STATUS_TEXT = {
    backlog: "Backlog",
    todo: "To Do",
    "in-progress": "In Progress",
    review: "Review",
    blocked: "Blocked / Human",
    done: "Done",
    cancelled: "Cancelled",
};
/** The words for a status; an id this table does not know is spaced and capitalised, never shown raw. */
export function taskStatusText(status) {
    if (!status)
        return "Unknown";
    const known = TASK_STATUS_TEXT[status.toLowerCase()] ?? TASK_STATUS_TEXT[status.toLowerCase().replace(/_/g, "-")];
    if (known)
        return known;
    const spaced = status.replace(/[_-]+/g, " ").trim();
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
//# sourceMappingURL=statusWords.js.map